import script from "./StepperBtns.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperBtns.vue?vue&type=script&setup=true&lang=js"

import "./StepperBtns.vue?vue&type=style&index=0&id=46146820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46146820"]])

export default __exports__